var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasJump())?_c('span',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.iconJump))])]}}],null,false,1413795579)},[_c('span',[_vm._v("This field can change the order in which survey pages are displayed.")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }